import { render, staticRenderFns } from "./SetSplit.vue?vue&type=template&id=ba31938c"
import script from "./SetSplit.vue?vue&type=script&lang=js"
export * from "./SetSplit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports